/**
 * CSV file management.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

/**
 * Generate a CSV file to the Download directory.
 *
 * @param filename The name of the file create
 * @param data The list of lines of data.
 * @param separtor The separator character.
 */
export function writeCsv(filename: string, data: any[], separtor: string = ',') {
  const csvContent = data.map((row) => row.join(separtor)).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
